
import { render } from '@testing-library/react';
import React from 'react';
import { useState } from 'react';

import { Link } from "react-router-dom";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import $ from 'jquery'
class MyAssessmentHTML extends React.Component {
    myFunction() {
        var x = document.getElementById("myDIV2");
        if (x.style.display === "block") {
            x.style.display = "none";
        } else {
            x.style.display = "block";
        }
    }

    showPopup() {
        $('.Show-upload-div').click(function () {
            $('.upload-img').show('slow');
        });
        $('.Hide-upload-div').click(function () {
            $('.upload-img').hide('slow');
        });
    }
    ShowUploadDiv2() {
        $('.Show-upload-div2').click(function () {
            $('.upload-emoji').show('slow');
        });
        $('.Hide-upload-div2').click(function () {
            $('.upload-emoji').hide('slow');
        });
    }


    render() {
        return (
            <div>

                <div id="circular-menu" className="circular-menu">

                    <a className="floating-btn" >
                        <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
                        <i aria-hidden="true" className="fa fa-times"></i>
                    </a>

                    <div className="items-wrapper">
                        <div className="menu-item is-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                        </div>
                        <a className="menu-item is-flex right-panel-trigger" data-panel="languages-panel">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                        </a>
                        <Link to="" className="menu-item is-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                        </Link>
                        <a className="menu-item is-flex right-panel-trigger" data-panel="activity-panel">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                        </a>
                    </div>

                </div>
                {/* <!-- row --> */}
                <div className="container-fluid">

                    <div className="row g-3 assessment-module">
                        <div className="col-xl-12">
                            <div className="form-head d-flex flex-wrap align-items-center">
                                <div className="me-auto">
                                    <h2 className="font-w600 mb-0">Employee Self Assessment</h2>
                                </div>
                                <div className="rightside-tabs">
                                    <select className='form-control'>
                                        <option disabled>Select Period</option>
                                        <option selected >01 April 2022 - 31 March 2023</option>
                                        <option>01 April 2021 - 31 March 2022</option>
                                        <option>01 April 2020 - 31 March 2021</option>
                                    </select>

                                    <button
                                        className="add-newticket w-auto float-right"
                                        style={{ minWidth: "fit-content" }}
                                    >
                                        Sumbit for review
                                    </button>
                                    <button
                                        className="add-newticket w-auto float-right"
                                        style={{ minWidth: "fit-content" }}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-9">
                            <div className="assessment-detail-block">
                                <div className="illustration-header00">
                                    <div className="header-meta">
                                        <div className="my-assessment-firstdiv">
                                            <img src='http://devbox.bizbrolly.com:4006/Uploads/images_2_9fff_202506301228.jpeg' className='profile-empimg' />
                                            <div>
                                                <h3>Savita Rana</h3>
                                                <ul className="basicinfomation">
                                                    <li><i className="fa fa-calendar" aria-hidden="true"></i>15 Feb 2023</li>
                                                    <li>
                                                        <i
                                                            className="fa fa-envelope-o"
                                                            aria-hidden="true"
                                                        ></i>
                                                        Designer-Engineering
                                                    </li>
                                                    <li>
                                                        <i className="fa fa-user-o" aria-hidden="true"></i>
                                                        A
                                                    </li>
                                                </ul>
                                            </div>

                                        </div>
                                        <div className="summary-stats">
                                            {/* <div className="summary-stat">
                                                                            <img src='images/pms/hr.jpg' className='hr-img' />
                                                                            <div>
                                                                                <span>Pragya Tiwari</span>
                                                                                <span>(HR Normalization)</span>
                                                                            </div>
                                                                        </div> */}
                                            <div className="summary-stat">
                                                <img src="http://localhost:3000/images/pms/start-date.svg" />
                                                <div>
                                                    <span>Started On</span>
                                                    <span>08 May 2023</span>
                                                </div>
                                            </div>
                                            <div className="summary-stat">
                                                <img src="http://localhost:3000/images/pms/start-date.svg" />
                                                <div>
                                                    <span>Ending On</span>
                                                    <span>15 May 2023</span>
                                                </div>
                                            </div>
                                            <div className="summary-stat">
                                                <img src="http://localhost:3000/images/pms/end-date.svg" />
                                                <div>
                                                    <span>SelfAssessment Last Date</span>
                                                    <span>22 May 2023</span>
                                                </div>
                                            </div>
                                            <div className="summary-stat">
                                                <img src="http://localhost:3000/images/pms/date.svg" />
                                                <div>
                                                    <span>Review End Date</span>
                                                    <span>26 May 2023</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="emprightside-tabss">
                                            <div className="stepper-wrapper00">
                                                <div className="stepper-item completed">
                                                    <div className="step-counter">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="16"
                                                            height="16"
                                                            fill="currentColor"
                                                            className="bi bi-check-all"
                                                            viewBox="0 0 16 16"
                                                        >
                                                            <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />
                                                        </svg>
                                                    </div>
                                                    <div className="step-name">Initiated</div>
                                                </div>
                                                <div className="stepper-item completed">
                                                    <div className="step-counter">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="16"
                                                            height="16"
                                                            fill="currentColor"
                                                            className="bi bi-check-all"
                                                            viewBox="0 0 16 16"
                                                        >
                                                            <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />
                                                        </svg>
                                                    </div>
                                                    <div className="step-name">Submitted</div>
                                                </div>
                                                <div className="stepper-item active">
                                                    <div className="step-counter">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="16"
                                                            height="16"
                                                            fill="currentColor"
                                                            className="bi bi-check-all"
                                                            viewBox="0 0 16 16"
                                                        >
                                                            <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />
                                                        </svg>
                                                    </div>
                                                    <div className="step-name">Reviewed</div>
                                                </div>
                                                <div className="stepper-item active">
                                                    <div className="step-counter">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="16"
                                                            height="16"
                                                            fill="currentColor"
                                                            className="bi bi-check-all"
                                                            viewBox="0 0 16 16"
                                                        >
                                                            <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />
                                                        </svg>
                                                    </div>
                                                    <div className="step-name">Closed</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="notice-div d-none">
                                <div className="first-coll">
                                    <img src="images/org-img/leave/1.png" className="w-100" />
                                </div>
                                <div className="second-coll">
                                    <p>Reference site about Lorem Ipsum, giving information on its origins, as well as a random Lipsueference site about Lorem Ipsum, giving information on its origins, as well as a random Lipsum generatortor.</p>
                                    {/* <!-- <button>View history</button> --> */}
                                </div>
                            </div>

                            <div className="assessment-questions-for-emp mb-3">
                                <div className="illustration-header00">
                                    <div className="header-meta">
                                        <div className="first-divblock">
                                            <h3>Self Assessment Form</h3>
                                            <div className='ml-auto'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-plus-lg" viewBox="0 0 16 16" style={{ cursor: "pointer" }}>
                                                    <path fillRule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                                </svg>
                                            </div>
                                        </div>

                                        <div className="questions-list">
                                            <div className='qa-for-emp'>
                                                <div className='list-number'>
                                                    <h5><span>1</span>Deliverables & Customer Focus</h5>
                                                    <p>Weightage: 50%</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16" style={{ cursor: "pointer" }}>
                                                        <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                    </svg>
                                                </div>
                                                <div>
                                                <p className='title'>Self Evaluation</p>
                                                <div className='textbox'>
                                                    <textarea className='form-control' rows={5} cols={1}></textarea>
                                                </div>
                                                <p className='title'><img className="avatar" src="http://localhost:3000/images/placeholder_profile.png" alt="" />Arun Mishra's Evaluation</p>
                                                <div className='textbox-for-reviewer'>
                                                    <textarea className='form-control' rows={2} cols={1}></textarea>
                                                    <input type='number' className='form-control' />
                                                </div>
                                                </div>
                                            </div>
                                            <div className='qa-for-emp'>
                                                <div className='list-number'>
                                                    <h5><span>2</span>Technical Competence & Strength</h5>
                                                    <p>Weightage: 20%</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16" style={{ cursor: "pointer" }}>
                                                        <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                    </svg>
                                                </div>
                                                <div>
                                                <p className='title'>Self Evaluation</p>
                                                <div className='textbox'>
                                                    <textarea className='form-control' rows={5} cols={1}></textarea>
                                                </div>
                                                <p className='title'><img className="avatar" src="http://localhost:3000/images/placeholder_profile.png" alt="" />Arun Mishra's Evaluation</p>
                                                <div className='textbox-for-reviewer'>
                                                    <textarea className='form-control' rows={2} cols={1}></textarea>
                                                    <input type='number' className='form-control' />
                                                </div>
                                                </div>
                                            </div>
                                            <div className='qa-for-emp'>
                                                <div className='list-number'>
                                                    <h5><span>3</span>Behavioural Strength/TeamWork</h5>
                                                    <p>Weightage: 10%</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16" style={{ cursor: "pointer" }}>
                                                        <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                    </svg>
                                                </div>
                                                <div>
                                                <p className='title'>Self Evaluation</p>
                                                <div className='textbox'>
                                                    <textarea className='form-control' rows={5} cols={1}></textarea>
                                                </div>
                                                <p className='title'><img className="avatar" src="http://localhost:3000/images/placeholder_profile.png" alt="" />Arun Mishra's Evaluation</p>
                                                <div className='textbox-for-reviewer'>
                                                    <textarea className='form-control' rows={2} cols={1}></textarea>
                                                    <input type='number' className='form-control' />
                                                </div>
                                                </div>
                                            </div>
                                            <div className='qa-for-emp'>
                                                <div className='list-number'>
                                                    <h5><span>4</span>Accountability & Communication</h5>
                                                    <p>Weightage: 10%</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16" style={{ cursor: "pointer" }}>
                                                        <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                    </svg>
                                                </div>
                                                <div>
                                                <p className='title'>Self Evaluation</p>
                                                <div className='textbox'>
                                                    <textarea className='form-control' rows={5} cols={1}></textarea>
                                                </div>
                                                <p className='title'><img className="avatar" src="http://localhost:3000/images/placeholder_profile.png" alt="" />Arun Mishra's Evaluation</p>
                                                <div className='textbox-for-reviewer'>
                                                    <textarea className='form-control' rows={2} cols={1}></textarea>
                                                    <input type='number' className='form-control' />
                                                </div>
                                                </div>
                                            </div>
                                            <div className='qa-for-emp'>
                                                <div className='list-number'>
                                                    <h5><span>5</span>Development Areas</h5>
                                                    <p>Weightage: 10%</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16" style={{ cursor: "pointer" }}>
                                                        <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                    </svg>
                                                </div>
                                                <div>
                                                <p className='title'>Self Evaluation</p>
                                                <div className='textbox'>
                                                    <textarea className='form-control' rows={5} cols={1}></textarea>
                                                </div>
                                                <p className='title'><img className="avatar" src="http://localhost:3000/images/placeholder_profile.png" alt="" />Arun Mishra's Evaluation</p>
                                                <div className='textbox-for-reviewer'>
                                                    <textarea className='form-control' rows={2} cols={1}></textarea>
                                                    <input type='number' className='form-control' />
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="assessment-questions-for-emp mb-3">
                                <div className="illustration-header00">
                                    <div className="header-meta">
                                        <div className="first-divblock">
                                            <h3>Final Rating</h3>
                                        </div>

                                        <ul className='my-comment-ul2'>
                                            <li className='final-rating'>
                                                <img className="avatar" src="http://localhost:3000/images/placeholder_profile.png" alt="" />
                                                <div>
                                                    <strong>Arun Mishra's <span>(First Reviewer)</span> </strong>
                                                    <p className='main-reviwer-comment'>
                                                        Generate Lorem Ipsum placeholder text htmlFor use in your graphic, print and web layouts, and discover plugins
                                                    </p>
                                                </div>
                                                <div>
                                                    <p className='ratetitle'>Rating</p>
                                                    <select className='form-control'>
                                                        <option>1</option>
                                                        <option>2</option>
                                                        <option>3</option>
                                                        <option>4</option>
                                                    </select>
                                                </div>
                                                <div>
                                                    <p className='ratetitle'>Average Criteria:</p>
                                                    <input type='number' className='form-control' />
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="assessment-questions-for-emp">
                                <div className="illustration-header00">
                                    <div className="header-meta">
                                        <div className="first-divblock">
                                            <h3>All Reviewer's Comment</h3>
                                        </div>

                                        <ul className='my-comment-ul2'>

                                            <li>
                                                <img className="avatar" src="http://localhost:3000/images/placeholder_profile.png" alt="" />
                                                <div>
                                                    <strong>Alisha Goyal <span>(Second Reviewer)</span> </strong>
                                                    <p className='main-reviwer-comment'>
                                                        Generate Lorem Ipsum placeholder text htmlFor use in your graphic, print anerate Lorem Ipsum placeholder text htmlFor use in your graphic, print and web layouts, and discover plugins
                                                    </p>
                                                </div>
                                            </li>

                                            <li>
                                                <img className="avatar" src="http://localhost:3000/images/placeholder_profile.png" alt="" />
                                                <div>
                                                    <strong>Pragya Tiwari <span>(Third Reviewer)</span> </strong>
                                                    <p className='main-reviwer-comment'>
                                                        Generate Lorem Ipsum placeholder text htmlFor .
                                                    </p>
                                                </div>
                                            </li>
                                            <li>
                                                <img className="avatar" src="http://localhost:3000/images/placeholder_profile.png" alt="" />
                                                <div>
                                                    <strong>Savita Rana <span>(Employees's Comment's)</span> </strong>
                                                    <p className='main-reviwer-comment'>
                                                        Generate Lorem Ipsum placeholder text htmlFor use in your graphic, print and web layouts, and discover plugins
                                                    </p>
                                                </div>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>




                        </div>

                        <div className="col-xl-3">
                            <div className="row sidecarddd">
                                <div className="col-xl-12">
                                    <div className="card">
                                        <div className="card-body contact-mandiv">
                                            <a className="timeline-panel text-muted profiledrop">
                                                <div className="action-list">
                                                    <div className="media-flex select-more">
                                                        <select className='form-control p-0'>
                                                            <option selected>My Reviwers</option>
                                                            <option> Subhash Reviwers</option>
                                                            <option> Chandan Reviwers</option>
                                                            <option> Mukesh Reviwers</option>
                                                        </select>
                                                        {/* <i className="fa fa-angle-down" aria-hidden="true"></i> */}
                                                    </div>
                                                    <div className="media-flex">
                                                        <div className="icon-wrap is-dark-primary is-dark-bg-3 is-dark-card-bordered done">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-short" viewBox="0 0 16 16">
                                                                <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4" />
                                                            </svg>
                                                        </div>
                                                        <div className="flex-meta">
                                                            <img className="avatar" src="http://localhost:3000/images/placeholder_profile.png" alt="" data-user-popover="3" />
                                                            <div>
                                                                <span>Alisha Goyal</span>
                                                                <p>(First Review)</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="media-flex">
                                                        <div className="icon-wrap is-dark-primary is-dark-bg-3 is-dark-card-bordered">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-short" viewBox="0 0 16 16">
                                                                <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4" />
                                                            </svg>
                                                        </div>
                                                        <div className="flex-meta">
                                                            <img className="avatar" src="http://localhost:3000/images/placeholder_profile.png" alt="" data-user-popover="3" />
                                                            <div>
                                                                <span>Arun Mishra</span>
                                                                <p>(Second Review)</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="media-flex">
                                                        <div className="icon-wrap is-dark-primary is-dark-bg-3 is-dark-card-bordered">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-short" viewBox="0 0 16 16">
                                                                <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4" />
                                                            </svg>
                                                        </div>
                                                        <div className="flex-meta">
                                                            <img className="avatar" src="http://localhost:3000/images/placeholder_profile.png" alt="" data-user-popover="3" />
                                                            <div>
                                                                <span>Pragya Tiwari</span>
                                                                <p>(Third Review)</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>


                                                {/* <!--  <button>Contact</button> --> */}
                                            </a>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

                <div className="modal fade" id="review-request" aria-modal="true" role="dialog">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title m-auto">
                                    Form Submitted Successfully. Now Sent the Review Request.</h5>

                            </div>
                            <div className="modal-body text-center">
                                <form>
                                    <div className="form-group text-left">
                                        <label>Request to</label>
                                        <div className='form-group'>
                                            <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" className='mr-3' />
                                            <label htmlFor="vehicle1" className='mr-4'> Employee review</label>
                                            <input type="checkbox" id="vehicle2" name="vehicle2" value="Car" className='mr-3' />
                                            <label htmlFor="vehicle2" className='mr-4'> Review</label>
                                            <input type="checkbox" id="vehicle3" name="vehicle3" value="Boat" className='mr-3' />
                                            <label htmlFor="vehicle3" className='mr-4'> HR review</label>
                                        </div>
                                    </div>
                                    <div className="form-group text-left">
                                        <label className="mt-3">Add your Comment</label>
                                        <textarea rows="4" cols="1" className="form-control"></textarea></div>

                                </form>


                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger light" data-bs-dismiss="modal">Cancel</button>
                                <button type="button" className="btn btn-primary">Sumbit</button>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        )
    }
}
export default MyAssessmentHTML;
